import {
  Button,
  Card,
  CardActions,
  CardContent,
  Container,
  Grid,
  styled,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import { PageHeader } from "components/Table/components";
import { useEffect, useState } from "react";
import { TabsContainer } from "./styledComps/TabsContainer";
import { TabsContainerLeftButtons } from "./styledComps/TabsContainerLeftButtons";
import { ItemsContainer } from "./styledComps/ItemsContainer";
import SyncIcon from "@mui/icons-material/Sync";

import { apiGetPersonsExcel } from "../../api/personApi";
import { apiGetProductsExcel } from "../../api/productApi";
import { apiGetFactorsExcel } from "../../api/factorApi";
import { apiGetTransactionsExcel } from "../../api/transactionApi";
import { apiGetTransfersExcel } from "../../api/transferApi";
import { apiGetAccountingsExcel } from "../../api/accountingApi";
import { apiGetRemittancesExcel } from "../../api/remittanceApi";
import { appSetModal } from "../../store/actions/appAction";

import ProjectExcelIcon from "../../assets/icons/excel/Project.svg";
import BranchExcelIcon from "../../assets/icons/excel/Branch.svg";
import FinancialExcelIcon from "../../assets/icons/excel/Financials.svg";
import WarehouseExcelIcon from "../../assets/icons/excel/Inventory.svg";
import AccountingExcelIcon from "../../assets/icons/excel/Accounting.svg";
import BillExcelIcon from "../../assets/icons/excel/Bill.svg";
import FactorsExcelIcon from "../../assets/icons/excel/Factor.svg";
import PersonsExcelIcon from "../../assets/icons/excel/Persons.svg";
import ProductExcelIcon from "../../assets/icons/excel/Product.svg";
import TransactionExcelIcon from "../../assets/icons/excel/Transaction.svg";
import TransfersExcelIcon from "../../assets/icons/excel/Transfers.svg";
import { apiGetLastSync, apiSync } from "../../api/syncApi";
// @ts-ignore
import { apiSetAlert } from "../../api/appApi";
// @ts-ignore
import momentJalaali from "moment-jalaali";
import { formatDate } from "../../helpers";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { useNavigate } from "react-router-dom";
import { apiGetFinancialsExcel } from "../../api/financialApi";
import { apiGetWarehousesExcel } from "../../api/warehouseApi";
import { apiGetProjectsExcel } from "../../api/projectApi";
import { apiGetBranchesExcel } from "../../api/branchApi";
import useResponsive from "helpers/useResponsive";
import { useAppDispatch, useAppSelector } from "store/store";

const NotAvailableContainer = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "center",
}));
const StyledButton = styled(Button)(({ theme }) => ({
  width: "144px",
  height: "44px",
  borderRadius: "4px",
}));

export const NotAvailable = ({ handleClick }: { handleClick: () => void }) => {
  const description =
    "همگام سازی اطلاعات و استفاده آفلاین برای اشتراک شما فعال نشده است. برای فعال سازی باید اشتراک خود را ارتقاء دهید";
  return (
    <Grid container padding="25px" flexDirection="column">
      <Grid item xs={12}>
        <Typography color="#666666" sx={{ mb: 3 }}>
          {description}
        </Typography>
      </Grid>
      <NotAvailableContainer>
        <StyledButton
          onClick={() => handleClick()}
          startIcon={<ShoppingCartOutlinedIcon />}
          disableRipple
          color="primary"
          variant="outlined"
        >
          &nbsp; ارتقاء اشتراک
        </StyledButton>
      </NotAvailableContainer>
    </Grid>
  );
};

export interface FileType {
  name: string;
  src: string;
  id: number | string;
}

export interface FileManagerProps {
  files?: FileType[];
}

const tabs = [
  {
    key: "download",
    label: "دانلود",
    pluralLabel: "دانلود",
    title: "دانلود",
    pageTitle: "مدیریت اطلاعات",
    pageDescription: "پشتیبان/بازگردانی اطلاعات کسب و کار",
    items: [
      {
        keys: ["customer", "personnel", "provider"],
        title: "اشخاص",
        exportAction: apiGetPersonsExcel,
        icon: PersonsExcelIcon,
      },
      {
        keys: ["product", "service"],
        title: "کالا/خدمات",
        exportAction: apiGetProductsExcel,
        icon: ProductExcelIcon,
      },
      {
        keys: ["bank", "fund", "cashier"],
        title: "حساب",
        exportAction: apiGetFinancialsExcel,
        icon: FinancialExcelIcon,
      },
      {
        keys: ["warehouse"],
        title: "انبار",
        exportAction: apiGetWarehousesExcel,
        icon: WarehouseExcelIcon,
      },
      {
        keys: ["project"],
        title: "پروژه",
        exportAction: apiGetProjectsExcel,
        icon: ProjectExcelIcon,
      },
      {
        keys: ["branch"],
        title: "شعب",
        exportAction: apiGetBranchesExcel,
        icon: BranchExcelIcon,
      },
      {
        keys: ["transfer"],
        title: "انتقال",
        exportAction: apiGetTransfersExcel,
        icon: TransfersExcelIcon,
      },
      {
        keys: ["sale", "buy", "saleReturn", "buyReturn", "waste","saleIsDraft","buyIsDraft"],
        title: "فاکتور",
        exportAction: apiGetFactorsExcel,
        icon: FactorsExcelIcon,
      },
      {
        keys: ["receive", "payment", "income", "cost"],
        title: "تراکنش",
        exportAction: apiGetTransactionsExcel,
        icon: TransactionExcelIcon,
      },
      {
        keys: ["enter", "exit"],
        title: "حواله انبار",
        exportAction: apiGetRemittancesExcel,
        icon: BillExcelIcon,
      },
      {
        keys: ["accounting"],
        title: "اسناد حسابداری",
        exportAction: apiGetAccountingsExcel,
        icon: AccountingExcelIcon,
      },
    ],
  },
  // {
  //     key: "sync",
  //     label: "همگام سازی",
  //     pluralLabel: "همگام سازی",
  //     title: "همگام سازی",
  //     pageTitle: "همگام سازی",
  //     pageDescription: "همگام سازی اطلاعات با سرور",
  //     items: [
  //         {
  //             key: ['accountType'],
  //             title: "جدول حساب ها",
  //             priority: 1,
  //             icon: AccountTypesIcon
  //         },
  //         {
  //             key: ['category'],
  //             title: "دسته بندی کالا/خدمات",
  //             priority: 2,
  //             icon: ProductTypesIcon
  //         },
  //         {
  //             key: ['personType'],
  //             title: "دسته بندی اشخاص",
  //             priority: 3,
  //             icon: PersonTypesIcon
  //         },
  //         {
  //             key: ['project'],
  //             title: "پروژه",
  //             priority: 4,
  //             icon: ProjectIcon
  //         },
  //         {
  //             key: ['branch'],
  //             title: "شعب",
  //             priority: 5,
  //             icon: BranchesIcon
  //         },
  //         {
  //             key: ['warehouse'],
  //             title: "انبار",
  //             priority: 6,
  //             icon: WarehousesIcon
  //         },
  //         {
  //             key: ['financial'],
  //             title: "حساب",
  //             priority: 7,
  //             icon: FinancialsIcon
  //         },
  //         {
  //             key: ['person', 'personSetting', 'shareholder'],
  //             title: "اشخاص",
  //             syncOrder: 8,
  //             icon: PersonIcon
  //         },
  //         {
  //             key: ['product', 'productSetting', 'barcode'],
  //             title: "کالا/خدمات",
  //             syncOrder: 9,
  //             icon: ProductIcon
  //         },
  //         {
  //             key: ['transfer'],
  //             title: "انتقال",
  //             syncOrder: 10,
  //             icon: TransferIcon
  //         },
  //         {
  //             key: ['factor'],
  //             title: "فاکتور",
  //             syncOrder: 11,
  //             icon: FactorIcon
  //         },
  //         {
  //             key: ['transaction'],
  //             title: "تراکنش",
  //             syncOrder: 12,
  //             icon: TransactionIcon
  //         },
  //         {
  //             key: ['cheque'],
  //             title: "چک",
  //             syncOrder: 13,
  //             icon: ChequesIcon
  //         },
  //         {
  //             key: ['bill'],
  //             title: "حواله انبار",
  //             syncOrder: 14,
  //             icon: BillIcon
  //         },
  //         {
  //             key: ['accounting'],
  //             title: "اسناد حسابداری",
  //             syncOrder: 15,
  //             icon: AccountingIcon
  //         }
  //     ]
  // },
];

export default function FileManager(props: FileManagerProps) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { isMobile } = useResponsive();

  const { business, token } = useAppSelector((state) => state).businessReducer.business;
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [lastSync, setLastSync] = useState([]);
  const [syncingModel, setSyncingModel] = useState(null);
  const changeActiveTab = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(tabs[newValue]);
    setActiveTabIndex(newValue);
  };

  useEffect(() => {
    dispatch(
      apiGetLastSync(token, (lastSync: any) => {
        setLastSync(lastSync);
      })
    );
  }, []);

  const clearData = () => {};

  const downloadAll = () => {
    for (const item of activeTab.items) {
      exportModel(item);
    }
  };

  const syncAll = () => {
    for (const item of activeTab.items) {
      syncModel(item);
    }
  };

  const exportModel = (item: any) => {
    for (const key of item.keys) {
      dispatch(item.exportAction(token, key));
    }
  };

  const importExcel = () => {
    dispatch(appSetModal({ component: "import-excel", maxWidth: "900px" }, true));
  };

  const syncModel = (item: any) => {
    setSyncingModel(item);
    for (const key of item.key) {
      dispatch(
        apiSync(
          token,
          key,
          (syncData: any) => {
            dispatch(apiSetAlert(`همگام سازی ${item.title} با موفقیت انجام شد`, "success"));
          },
          () => syncFailure(item)
        )
      );
    }
  };

  const syncFailure = (item: any) => {
    setSyncingModel(null);

    dispatch(apiSetAlert("خطا در همگام سازی اطلاعات " + item.title, "error"));
  };

  const getLastSyncDifference = (lastSync: any) => {
    if (lastSync) {
      const today = momentJalaali();
      const lastSyncDate = momentJalaali(lastSync.createdAt);
      const lastSyncMinutes = parseInt((today.diff(lastSyncDate) / 60000).toString());

      if (lastSyncMinutes > 720) {
        lastSync.difference = formatDate(lastSync.createdAt, false, true, "jD jMMMM");
      } else if (lastSyncMinutes < 3) {
        lastSync.difference = `لحظاتی پیش`;
      } else if (lastSyncMinutes < 60) {
        lastSync.difference = `${lastSyncMinutes} دقیقه پیش`;
      } else {
        lastSync.difference = `${parseInt((lastSyncMinutes / 60).toString())} ساعت پیش`;
      }

      return lastSync;
    }
  };

  const haveOfflinePlan = () => business.subscription && [4, 10, 11, 12].includes(business.subscription.id);

  return (
    <Container maxWidth="xl">
      <div className="warp-table">
        <div className="header-table">
          <PageHeader activeTab={activeTab} />
          {activeTab.key === "download" && (
            <div style={{ display: "flex", alignItems: "center", padding: "0 10px" }}>
              <StyledButton
                variant="contained"
                startIcon={<AddIcon style={{ margin: 0 }} />}
                onClick={importExcel}
              >
                &nbsp;آپلود اطلاعات&nbsp;
              </StyledButton>
            </div>
          )}
        </div>
        <div>
          <TabsContainer>
            <Tabs value={activeTabIndex} onChange={changeActiveTab} aria-label="basic tabs example">
              {tabs &&
                tabs.length > 1 &&
                tabs.map((tab, index) => {
                  return <Tab key={index} label={tab.title} />;
                })}
            </Tabs>

            <TabsContainerLeftButtons>
              {
                activeTab.key === "download" ? (
                  <>
                    {/*<StyledButton variant="outlined" onClick={clearData} startIcon={<TrashIcon/>}>پاکسازی*/}
                    {/*    اطلاعات</StyledButton>*/}
                    <StyledButton variant="outlined" onClick={downloadAll} startIcon={<DownloadIcon />}>
                      &nbsp;دانلود همه
                    </StyledButton>
                  </>
                ) : null
                // (haveOfflinePlan() && <StyledButton variant="outlined" onClick={syncAll}>همگام سازی
                //     همه</StyledButton>)
              }
            </TabsContainerLeftButtons>
          </TabsContainer>
          <ItemsContainer isMobile={isMobile}>
            {activeTab.key === "sync" && !haveOfflinePlan() ? (
              <NotAvailable handleClick={() => navigate("/business/extend")} />
            ) : (
              activeTab.items.map((item, index) => {
                return (
                  <div key={index} style={{}}>
                    <Card>
                      <CardContent style={{ textAlign: "center" }}>
                        <img style={{ display: "initial" }} src={item.icon} />
                        <Typography gutterBottom variant="h6" component="div">
                          {item.title}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {/*{newRecords.find(record => item.keys.includes(record)) ?? 0}{" اطلاعات جدید"}*/}
                        </Typography>
                      </CardContent>
                      <CardActions disableSpacing>
                        <div
                          style={{
                            display: "flex",
                            width: "100%",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            // justifyContent: activeTab.key === 'download' ? 'center' : 'space-between'
                          }}
                        >
                          {activeTab.key === "syncc" && (
                            <div>
                              <Typography variant="body2" color="text.secondary">
                                آخرین همگام سازی:
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                یافت نشد
                              </Typography>
                            </div>
                          )}
                          {activeTab.key === "download" && (
                            <div>
                              <Button
                                onClick={() => {
                                  if (activeTab.key === "download") {
                                    exportModel(item);
                                  } else {
                                    syncModel(item);
                                  }
                                }}
                                variant="outlined"
                                color="primary"
                                style={{
                                  border: "0px",
                                  marginRight: "5px",
                                  fontSize: "14px",
                                }}
                                startIcon={activeTab.key === "download" ? <DownloadIcon /> : <SyncIcon />}
                              >
                                <span style={{ marginRight: "5px" }}>
                                  {activeTab.key === "download" ? "دانلود اکسل" : "همگام سازی"}
                                </span>
                              </Button>
                            </div>
                          )}
                        </div>
                      </CardActions>
                    </Card>
                  </div>
                );
              })
            )}
          </ItemsContainer>
        </div>
      </div>
    </Container>
  );
}
